// passing the path into variables

const destination1 = '/assets/tarapaca/arica.png'
const destination2 = '/assets/tarapaca/iquique.png'
const destination3 = '/assets/tarapaca/calama.png'
const destination4 = '/assets/tarapaca/hospicio.png'
const destination5 = '/assets/tarapaca/antofagasta.png'
const destination6 = '/assets/tarapaca/colchane.png'
const destination7 = '/assets/tarapaca/almonte.png'





const gallery1 = '/assets/tarapaca/gallery-one.png';
const gallery2 = '/assets/tarapaca/gallery-two.png';
const gallery3 = '/assets/tarapaca/gallery-three.png';
const gallery4 = '/assets/tarapaca/gallery-four.png';


const destination = [destination1, destination2, destination3, destination4, destination5, destination6, destination7,];
const gallery = [gallery1, gallery2, gallery3, gallery4];


const tarapacaSlides = {
	destination,
	gallery
}

export default tarapacaSlides


// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/tarapacaSlides.js